// src/App.js
import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import AppNavbar from "./components/AppNavbar";
import HomePage from "./pages/HomePage";
import LearnPage from "./pages/LearnPage";
import PracticePage from "./pages/PracticePage";
import ToolsPage from "./pages/ToolsPage";
import GamesPage from "./pages/GamesPage";
import QuizGamePage from "./pages/QuizGamePage";
import ShaftGamePage from "./pages/ShaftGamePage";
import MatchGamePage from "./pages/MatchGamePage";
import SimulatorPage from "./pages/SimulatorPage";
import KnowPage from "./pages/KnowPage";
import NotFoundPage from "./pages/NotFoundPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import AppFooter from "./components/AppFooter";
import ModelPreloader from "./components/ModelPreloader";
import ScrollToTop from "./components/ScrollToTop"; 
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  // Models to preload
  const modelsToPreload = [
    '/timmy.draco.glb',  // Preload the Draco compressed model
    '/timmy.glb'         // Fallback another Draco compressed model as backup
  ];

  useEffect(() => {
    const existing = localStorage.getItem('learntSigns');
    if (!existing) {
      const initialData = {
        letter: [],
        number: [],
        common: []
      };
      localStorage.setItem('learntSigns', JSON.stringify(initialData));
      console.log("🔑 Local storage for learntSigns initialized!");
    }
  }, []);

  return (
    <>
      <AppNavbar />
      {/* Preload 3D models in the background */}
      <ModelPreloader modelPaths={modelsToPreload} />
      <ScrollToTop />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/learn" element={<LearnPage />} />
          <Route path="/practice" element={<PracticePage />} />
          <Route path="/tools" element={<ToolsPage />} />
          <Route path="/games" element={<GamesPage />} />
          <Route path="/games/quiz" element={<QuizGamePage />} />
          <Route path="/games/shaft" element={<ShaftGamePage />} />
          <Route path="/games/match" element={<MatchGamePage />} />
          <Route path="/simulator" element={<SimulatorPage />} />
          <Route path="/info" element={<KnowPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsOfUsePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
      <AppFooter />
    </>
  );
}

export default App;
